import 'rxjs';
import { combineEpics, ofType } from 'redux-observable';
import { mapTo } from 'rxjs/operators';

import { LOCATION_CHANGE } from 'connected-react-router';

import { MODAL_TERMS_AND_CONDITIONS_LOGIN } from 'modules/messageSystem/constants/modalCodes';
import { removeModal } from 'modules/messageSystem/actions/removeModal';
import { acceptTermsAndConditions } from '../actions/acceptTermsAndConditions';

import {
  TOS_NEED_APPROVE,
  TOS_ACCEPTED,
  TOS_DECLINED,
  TOS_DECLINE_CANCELED,
  showTermsAndConditionsModal,
  showAcceptDeclineTermsAndConditionsModal,
} from '../actions/termsOfService';

const getToS = (action$) =>
  action$
    .pipe(
      ofType(TOS_NEED_APPROVE, TOS_DECLINE_CANCELED),
      mapTo(showTermsAndConditionsModal()),
    );

const showAcceptDeclineToSModal = (action$) =>
  action$
    .pipe(
      ofType(TOS_DECLINED),
      mapTo(showAcceptDeclineTermsAndConditionsModal()),
    );

const setToSAccepted = (action$) =>
  action$
    .pipe(
      ofType(TOS_ACCEPTED),
      mapTo(acceptTermsAndConditions()),
    );

export const closeLoginTermsOfServiceModal = (action$) =>
  action$
    .pipe(
      ofType(LOCATION_CHANGE),
      mapTo((dispatch, getState) => {
        const state = getState();
        const termsModal = state.messageSystem.modals.queue
          .find(({ typeId }) => typeId === MODAL_TERMS_AND_CONDITIONS_LOGIN);

        if (termsModal && termsModal.id) {
          dispatch(removeModal(termsModal.id));
        }
      }),
    );

export default combineEpics(
  getToS,
  showAcceptDeclineToSModal,
  setToSAccepted,
  closeLoginTermsOfServiceModal,
);
